import { makeAuthenticatedRequestWithHandling } from "./api";

// subscriptions.js in the utils folder
export const getSubscriptionDetails = async (classroomId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/${classroomId}`,
      "GET"
    );
    return response.json();
  } catch (error) {
    console.error("Error during fetching subscription:", error);
    return { ok: false, error: error };
  }
};

export const getSubscriptionById = async (classroomId, subscriptionId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/${classroomId}/${subscriptionId}`,
      "GET"
    );

    return response.json();
  } catch (error) {
    console.error("Error during fetching subscription:", error);
    return { ok: false, error: error };
  }
};

export const getSubscription = async (subscriptionId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/${subscriptionId}/${subscriptionId}?detail=true`,
      "GET"
    );

    return response.json();
  } catch (error) {
    console.error("Error during fetching subscription:", error);
    return { ok: false, error: error };
  }
};

export const getSubscriptionByUserId = async (classroomId, studentId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/student/${classroomId}/${studentId}`,
      "GET"
    );
    return response.json();
  } catch (error) {
    console.error("Error during fetching subscription:", error);
    return { ok: false, error: error };
  }
};

export const assignPackage = async (
  classroomId,
  subscriptionId,
  formatData = null,
  toastText
) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/assign/${classroomId}/${subscriptionId}`,
      "POST"
      // formatData,
      // toastText
    );
    return response;
  } catch (error) {
    console.error("Error during fetching subscription:", error);
    return { ok: false, error: error };
  }
};

export const createNewSubscription = async (
  classroomId,
  formatData,
  toastText
) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/${classroomId}`,
      "POST",
      formatData,
      toastText
    );
    return response;
  } catch (error) {
    console.error("Error during creating subscription:", error);
    return { ok: false, error: error };
  }
};

export const updateSingleSubscription = async (
  classroomId,
  subscriptionId,
  formatData,
  toastText
) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/${classroomId}/${subscriptionId}`,
      "PATCH",
      formatData,
      toastText
    );
    return response;
  } catch (error) {
    console.error("Error during deleting subscription:", error);
    return { ok: false, error: error };
  }
};

export const updateSubscription = async (formatData, toastText) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/setHidden`,
      "PATCH",
      formatData,
      toastText
    );
    return response;
  } catch (error) {
    console.error("Error during deleting subscription:", error);
    return { ok: false, error: error };
  }
};

// subscriptions.js in the utils folder

export const deleteSubscription = async (
  classroomId,
  subscriptionId,
  toastText
) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/${classroomId}/${subscriptionId}`,
      "DELETE",
      null, // No body data for DELETE requests
      toastText
    );
    return response;
  } catch (error) {
    console.error("Error during deleting subscription:", error);
    return { ok: false, error: error };
  }
};

export const initiatePayment = async (paymentData, toastText) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/payments/begin`,
      "POST",
      paymentData,
      toastText
    );
    return response.json();
  } catch (error) {
    console.error("Error during payment initiation:", error);
    return { ok: false, error: error };
  }
};

export const initiateAlfalahPayment = async (paymentData, toastText) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/payments/beginAlfa`,
      "POST",
      paymentData,
      toastText
    );
    return response.json();
  } catch (error) {
    console.error("Error during Alfalah payment initiation:", error);
    return { ok: false, error: error };
  }
};

export const duplicateSubscription = async (classroomId, subscriptionId) => {
  try {
    const response = await makeAuthenticatedRequestWithHandling(
      `/subscriptions/import/${classroomId}/${subscriptionId}`,
      "POST"
    );
    return response.json();
  } catch (error) {
    console.error("Error during duplicating subscription:", error);
    return { ok: false, error: error };
  }
};
